import { useEffect, useRef } from "react";
import { v4 as uuidv4 } from "uuid";

const useCrossTabReload = () => {
	const channelRef = useRef<BroadcastChannel | null>(null);

	let tabId = sessionStorage.getItem("tabId");
	if (!tabId) {
		// tabId = crypto.randomUUID(); // не поддерживается почему-то
		tabId = uuidv4();
		sessionStorage.setItem("tabId", tabId);
	}
	const tabIdRef = useRef(tabId);

	useEffect(() => {
		channelRef.current = new BroadcastChannel("app_sync");

		channelRef.current.onmessage = (event) => {
			const { type, from } = event.data || {};
			if (!type) return;

			// запрещаем перезагрузку текущей вкладки
			if (from === tabIdRef.current) return;

			if (type === "DATA_CHANGED") {
				window.location.reload();
			}
		};

		return () => {
			channelRef.current?.close();
		};
	}, []);

	const notifyDataChanged = () => {
		// текущая вкладка только сообщает, не перезагружаясь сама
		channelRef.current?.postMessage({
			type: "DATA_CHANGED",
			from: tabIdRef.current,
		});
	};

	return { notifyDataChanged };
};

export default useCrossTabReload;
